module.exports = __webpack_public_path__ + "img/AddBuildingAddress.f2b9758f.png";